import imageImporterImage from './image.png';
import ImageImporterApp from './App.vue';

export var appConfig = {
	id: 'frontend-image-importer',
	name: 'image-importer',
	version: '1.0.0',
	hash: '',
	type: 'importer',
	title: 'Image Importer',
	author: 'Au-Zone Technologies',
	docs: 'https://doc.edgefirst.ai/latest/datasets/tutorials/capture/#upload-images',
	description: 'Import images into an existing dataset or a new dataset in EdgeFirst Studio.',
	date: new Date().toISOString(),
	runs: 0,
	price: 0,
	image: imageImporterImage,
	component: ImageImporterApp,
	actionLabel: 'Start Import',
	permission: '',
	is_hidden: false,
	user_launchable: true,
};